import React from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Card,
  CardContent,
  InputAdornment,
} from '@mui/material';
import Logo from '../pages/images/LIVA Logo - 3x.png';

const Unauthorized = () => {
    return (
        
        <>
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '15%',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                  textAlign: 'left',
                }}
              >
                <img src={Logo} style={{ width: '200px', height: 'auto' }}/>
                <Typography
                  variant="h1"
                  sx={{
                    color: '#002f6c',
                    fontWeight: 'bold',
                    fontSize: '4.5rem',
                    lineHeight: 1.2,
                    fontFamily: 'Mulish-Bold, sans-serif',
                  }}
                >
                  Unauthorized Request!
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    color: '#37485f',
                    fontSize: '3rem',
                    lineHeight: 1.2,
                    fontFamily: 'Mulish-Bold, sans-serif',
                  }}
                >
                  Kindly login again via EQOUTE application.
                </Typography>
              </Box>
        </>
    )
}
export default Unauthorized;